<template>
  <div>
    <div class="app-wrapper">
      <div class="app-player">
        <div ref="bgmarquee" class="player__bgmarquee">
          <div v-for="index in 3" :key="index">
            <div class="player__container">
              <div class="marquee3k" :data-speed="randomNumber(index)" data-reverse="true">
                <span class="player__marquee">EXPLICATE.&#160;ATMOSPHERE.&#160;</span>
              </div>
            </div>
            <div class="player__container">
              <div class="marquee3k" :data-speed="randomNumber(index)" data-reverse="true">
                <span class="player__marquee">UNLIMITED.&#160;NURTURE&#160;</span>
              </div>
            </div>
            <div class="player__container">
              <div class="marquee3k" :data-speed="randomNumber(index)" data-reverse="true">
                <span class="player__marquee">VOICE.&#160;IN&#160;PERPETUITY.&#160;</span>
              </div>
            </div>
            <div class="player__container">
              <div class="marquee3k" :data-speed="randomNumber(index)" data-reverse="true">
                <span class="player__marquee">INDUCTOR.&#160;EVERLASTING.&#160;</span>
              </div>
            </div>
            <div class="player__container">
              <div class="marquee3k" :data-speed="randomNumber(index)" data-reverse="true">
                <span class="player__marquee">IN&#160;PERPETUITY.&#160;UNLIMITED.&#160;</span>
              </div>
            </div>
          </div>
        </div>
        <div class="app-player__controls">
          <div v-if="timedUpdate === true">
          <div class="app-player__heading"><a href="https://freethoughtfm.bandcamp.com/" target="_blank">Click here<br>to listen to the<br>FREETHOUGHTFM<br>RADIO ARCHIVE</a></div>
          </div>
          <div v-else>
              <audio id="audioPlayer" :src="playerUrl" preload="none"></audio>
              <a href="#" v-show="isplaying === false" class="app-player__play" v-on:click.prevent="player('play')"><img src="../assets/images/play-icon.svg" alt="Play"></a>
              <a href="#" v-show="isplaying === true" class="app-player__pause" v-on:click.prevent="player('pause')"><img src="../assets/images/pause-icon.svg" alt="Pause"></a>
              <div class="app-player__notice">LISTEN LIVE NOW</div>
              <div class="app-player__wave" v-show="showWave === true"><img src="../assets/images/soundwave-gif.gif" alt="Wave"></div>
          </div>
        </div>
      </div>

      <div class="app-content__block">
        <div class="app-content__body mobile--center">
          <h1 class="app-content__title">THIS IS <span class="text--highlight">FREE THOUGHT FM</span>.</h1>

          <div v-if="timedUpdate === true">
            <p>AN ARTWORK, DEVELOPED BY ARTIST GARRETT PHELAN, THAT TALKS ABOUT THE IDEA OF ‘FREE THOUGHT’. THE PROJECT ALSO ASKS ABOUT ACCESS TO EDUCATION AND EXPLORES CLASS INEQUALITY IN DUBLIN.</p>
            <p>ACCESS TO EDUCATIONAL RESOURCES IS UNEQUAL. THE CURRENT SYSTEM NEEDS TO CHANGE. FREE THOUGHT FM WAS AN OPEN FORUM WHERE THESE ISSUES WERE EXPLORED.</p>
            <p>FREE THOUGHT FM TOOK PLACE IN <a href="http://www.douglashydegallery.com/" target="_blank">The Douglas Hyde Gallery</a> IN TRINITY COLLEGE, AND USED THE GALLERY AS A SAFE PLACE TO SHARE IDEAS. AT THE CORE OF THIS PROJECT WAS A 30-DAY TEMPORARY LICENSED FM RADIO STATION BROADCASTING LIVE FROM THE GALLERY. HERE, GARRETT SPOKE DAILY WITH INVITED FREE THINKERS, AND MEMBERS OF THE PUBLIC.</p>
            <p>THE FREE THOUGHT FM EXHIBITION BEGAN ON 15 MARCH, AND RAN UNTIL 25 MAY 2019. DURING THIS, THE FREE THOUGHT FM LIVE BROADCAST RAN FROM 25 MARCH UNTIL 23 APRIL ON 105.2FM (GREATER DUBLIN AREA ONLY), AND NATIONALLY/INTERNATIONALLY ONLINE HERE.</p>
          </div>
          <div v-else>
            <p>A NEW ARTWORK, DEVELOPED BY ARTIST GARRETT PHELAN, THAT TALKS ABOUT THE IDEA OF ‘FREE THOUGHT’. THE PROJECT ALSO ASKS ABOUT ACCESS TO EDUCATION AND EXPLORES CLASS INEQUALITY IN DUBLIN.</p>
            <p>ACCESS TO EDUCATIONAL RESOURCES IS UNEQUAL. THE CURRENT SYSTEM NEEDS TO CHANGE. FREE THOUGHT FM IS AN OPEN FORUM WHERE THESE ISSUES CAN AND WILL BE EXPLORED.</p>
            <p>FREE THOUGHT FM TAKES PLACE IN <a href="http://www.douglashydegallery.com/" target="_blank">The Douglas Hyde Gallery</a> IN TRINITY COLLEGE, AND USES THE GALLERY AS A SAFE PLACE TO SHARE IDEAS. AT THE CORE OF THIS PROJECT IS A 30-DAY TEMPORARY LICENSED FM RADIO STATION BROADCASTING LIVE FROM THE GALLERY. HERE, GARRETT WILL SPEAK DAILY WITH INVITED FREE THINKERS, AND MEMBERS OF THE PUBLIC.</p>
            <p>THE FREE THOUGHT FM EXHIBITION BEGAN ON 15 MARCH, AND WILL RUN UNTIL 25 MAY 2019. DURING THIS, THE FREE THOUGHT FM LIVE BROADCAST RUNS FROM 25 MARCH UNTIL 23 APRIL ON 105.2FM (GREATER DUBLIN AREA ONLY), AND NATIONALLY/INTERNATIONALLY ONLINE HERE.</p>
          </div>
        </div>
      </div>
      <div class="app-mobile-marquee">
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.4" data-reverse="true">
            <span class="app-mobile-marquee__marquee">THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;<span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span></span>
          </div>
        </div>
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.2" data-reverse="true">
            <span class="app-mobile-marquee__marquee"><span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span>THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;</span>
          </div>
        </div>
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.6" data-reverse="true">
            <span class="app-mobile-marquee__marquee">THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;<span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span></span>
          </div>
        </div>
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.4" data-reverse="true">
            <span class="app-mobile-marquee__marquee"><span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span>THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;</span>
          </div>
        </div>
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.4" data-reverse="true">
            <span class="app-mobile-marquee__marquee">THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;<span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span></span>
          </div>
        </div>
        <div class="app-mobile-marquee__container">
          <div class="marquee3k" :data-speed="0.2" data-reverse="true">
            <span class="app-mobile-marquee__marquee"><span>15&#160;MARCH&#160;-&#160;25&#160;MAY&#160;2019&#160;</span>THE&#160;DOUGLAS&#160;HYDE&#160;GALLERY&#160;</span>
          </div>
        </div>
      </div>
      <div class="app-content__block app-content__body--purple" ref="dark-block">
        <div class="app-content__body">
          <h2 class="app-content__title"><span class="text--highlight">Contact</span></h2>
          <p>To learn more about different routes to accessing third level education in Ireland, take a look at our easy to understand information <span><a target="_blank" href="FreethoughtFM_Booklet_A5_FA_Web.pdf">booklet</a>.</span></p>
          <p>FREE THOUGHT FM welcomes and will engage with all feedback, both negative and positive, from our listeners concerning any aspect of it as a work of art in due course. to give your feedback please email us at <a href="mailto:info@freethoughtfm.com">info@freethoughtfm.com</a></p>
          <p>For more information about our complaints, privacy and copyright policies, please visit our <a href="#" v-on:click.prevent="toggleModal()">policies</a> page.</p>
        </div>
        <div class="app-content__footer">
          <div class="app-content__footer__inner">
            <div class="app-content__social">
              <ul>
                <li><a href="https://www.instagram.com/freethoughtfm/" target="_blank"><img src="../assets/images/instagram-icon-white.svg" alt="Instagram"></a></li>
                <li><a href="https://www.facebook.com/FreeThoughtFM" target="_blank"><img src="../assets/images/facebook-icon-white.svg" alt="Facebook"></a></li>
              </ul>
            </div>
            <div class="app-content__social app-content__social-mobile">
              <ul>
                <li><a href="https://www.instagram.com/freethoughtfm/" target="_blank"><img src="../assets/images/instagram-icon.svg" alt="Instagram"></a></li>
                <li><a href="https://www.facebook.com/FreeThoughtFM" target="_blank"><img src="../assets/images/facebook-icon.svg" alt="Facebook"></a></li>
              </ul>
            </div>
            <div class="app-content__terms">All Material © Garrett Phelan 2019</div>
            <div class="app-mobile__sponsor"><img src="../assets/images/arts-council-dark.svg" alt="Arts Council"></div>
          </div>
        </div>
      </div>
      <a href="#" class="app-scroller" ref="app-scroller" v-on:click.prevent="scrollPage">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.2 150"><title>arrow-icon</title><g id="txt"><path fill="#8700ff" d="M105.18,94.46a3.46,3.46,0,0,0-4.89,0L56.56,138.18V3.46a3.46,3.46,0,1,0-6.92,0V138.18L5.91,94.46A3.46,3.46,0,0,0,1,99.35l49.46,49.46.09.08a3.43,3.43,0,0,0,5.06,0l.09-.08,49.46-49.46A3.46,3.46,0,0,0,105.18,94.46Z"/></g></svg>
    </a>
    </div>
    <Modal v-bind="{ modalClose: toggleModal, modalShow, customClass: 'custom_modal_class'}" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import { TweenMax, ScrollToPlugin, Power3 } from 'gsap/all'
const plugins = [ ScrollToPlugin ]
import Modal from '@/components/Modal.vue'
import moment from 'moment'

export default {
  name: 'home',
  data: () => ({
    modalShow: false,
    playerUrl: '',
    isplaying: false,
    scrolled: false,
    showWave: false,
    timedUpdate: false
  }),
  components: {
    Modal
  },
  created () {
    window.addEventListener('scroll', this.checkScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.checkScroll)
  },
  mounted () {
    var self = this
    setTimeout(function () {
        self.$marquee3k.init()
    }, 400)
    // Load player
    this.loadPlayer()
    this.dateCheck()
  },
  methods : {
    randomNumber: function () {
      return (Math.floor(Math.random() * (5 - 1 + 1)) + 1) / 10
    },
    scrollPage: function (el) {
      var body = document.body,
          html = document.documentElement;
      var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
      var distanceBottom = height - window.scrollY
      var arrow = this.$refs['app-scroller']

      if (arrow.classList.contains('isbottom')) {
        TweenMax.to(window, 2, {
          scrollTo: { y: 0, offsetY: 0 },
          autoKill:true,
          ease: Power3.easeOut
        })      
      } else {
        TweenMax.to(window, 3, {
          scrollTo: { y: distanceBottom, offsetY: 0 },
          autoKill:true,
          ease: Power3.easeOut
        })
      }
    },
    isInViewport: function (el) {
      const scroll = window.scrollY || window.pageYOffset
      const boundsTop = el.getBoundingClientRect().top + scroll
      const viewport = {
        top: scroll,
        bottom: scroll + window.innerHeight,
      }
      const bounds = {
        top: boundsTop,
        bottom: boundsTop + el.clientHeight,
      }
      return ( viewport.top >= (bounds.top - (viewport.bottom - viewport.top)))
    },
    checkScroll: function (el) {
      var darkBlock = document.querySelector('.app-content__body--purple'); 
      var arrow = this.$refs['app-scroller']
      if (this.isInViewport(darkBlock)) {
        arrow.classList.add('isdark')
      } else {
        if (arrow.classList.contains('isdark')) {
          arrow.classList.remove('isdark')
        }
      }
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight) {
         arrow.classList.add('isbottom')
      } else {
        if (arrow.classList.contains('isbottom')) {
          arrow.classList.remove('isbottom')
        }        
      }
    },
    loadPlayer: function () {
      axios
        .get('http://freethoughtfm.airtime.pro/api/station-metadata')
        .then(response => {
          this.playerUrl = response.data.stream_data.s1.url
      })
    },
    player: function (action) {
      var self = this
      var audioPlayer = document.getElementById("audioPlayer")
      if (action == "play") {
        audioPlayer.play()
        this.isplaying = true
        setTimeout(function () {
          self.showWave = true
        }, 2000)
      }
      if (action == "pause") {
        audioPlayer.pause()
        audioPlayer.src = audioPlayer.src
        this.isplaying = false
        this.showWave = false
      } 
    },
    toggleModal: function () {
      this.modalShow = !this.modalShow
    },
    dateCheck: function () {
      if (moment.utc().isAfter('2019-04-23T23:00:00Z')) {
        this.timedUpdate = true;
      }
    }   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
